import React, { useEffect, useState } from "react";
import SearchSelectStore from "../Partners/Store/SearchSelectStore";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Form, Formik, useFormik } from "formik";
import { fetchStores } from "../../../redux/Thunk/Store/StoreThunks";
import {
  fetchOrdersOfStore,
} from "../../../redux/Thunk/Order/OrderThunks";
import { debounce } from "lodash";
import Button from "../../common/Button";
import Packed from "../../common/icons/Packed";
import CheckedBg from "../../common/icons/CheckedBg";
import Shipping from "../../common/icons/Shipping";
import DobbleCheck from "../../common/icons/DobbleCheck";
import Complete from "../../common/icons/Complete";
import OpenLink from "../../common/icons/OpenLink";
import Pagination from "../../common/Pagination";
import Loader from "../../Loader";
import {
  OrderFilterButtons,
  OrderStatusButtons,
} from "../../../utils/constants";
import { getProductRowTags } from "../../../utils/helpers";
import ButtonGroup from "../../common/ButtonGroup";
import { setStoreById } from "../../../redux/Reducer/Store/StoreSlice";
import Input from "../../common/Input";

const StoreDashboard = () => {
  const { stores, storeById } = useSelector(
    ({ store }) => ({
      stores: store?.stores,
      storeById: store?.storeById,
    }),
    shallowEqual
  );
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);
  const [orderViewStates, setOrderViewStates] = useState({});
  const [selected, setSelected] = useState("all");
  const [filterByStatus, setFilterByStatus] = useState("all");
  const [selectedStore, setSelectedStore] = useState({});

  const [counts, setCounts] = useState({
    all: 0,
    clinic: 0,
    collect: 0,
    address: 0,
  });
  const [statusCounts, setStatusCounts] = useState({
    all: 0,
    accept: 0,
    packed: 0,
    dispatched: 0,
    delivered: 0,
    cancelled: 0,
    collected: 0,
  });
  useEffect(() => {
    const handleKeyPress = (event) => {
      switch (event.key) {
        case "F1":
          event.preventDefault();
          setSelected("all");
          break;
        case "F2":
          event.preventDefault();
          setSelected("clinic");
          break;
        case "F3":
          event.preventDefault();
          setSelected("collect");
          break;
        case "F4":
          event.preventDefault();
          setSelected("address");
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  const getPayload = (selected, filterByStatus) => {
    const validAddressTypes = {
      all: "",
      clinic: "isClinic",
      collect: "isCollect",
      address: "isAddress",
    };

    const validOrderTypes = {
      all: "",
      accept: "isAccepted",
      packed: "isPacked",
      dispatched: "isDispatched",
      delivered: "isDelivered",
      cancelled: "isCancelled",
      collected: "isCollected",
    };

    return {
      addressType: validAddressTypes[selected] || "",
      orderType: validOrderTypes[filterByStatus] || "",
    };
  };

  const {
    storeOrders: data,
    loading,
    invoiceDetails,
  } = useSelector((state) => state?.order);

  const formik = useFormik({
    initialValues: { storeId: "" },
    validateOnChange: false,
  });
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchStores());
    dispatch(setStoreById({}));
    setSelectedStore("");
  }, [dispatch]);

  useEffect(() => {
    const payload = getPayload(selected, filterByStatus);

    if (payload && Object.keys(payload).length > 0) {
      setCurrentPage(1);
    }
  }, [selected, filterByStatus]);

  useEffect(() => {
    const id = storeById?.SID;
    const debouncedFetchOrders = debounce((page, limit, payload) => {
      dispatch(fetchOrdersOfStore({ page, limit, payload, id }));
    }, 300);

    // const payload = getPayload(selected, filterByStatus);
    const payload = getPayload(selected, filterByStatus);

    if ((currentPage >= 1 || !data?.orders?.length) && id) {
      debouncedFetchOrders(currentPage, limit, payload);
    }

    return () => {
      debouncedFetchOrders.cancel();
    };
  }, [dispatch, currentPage, limit, storeById, selected, filterByStatus, data?.orders?.length]);

  // useEffect(() => {
  //   if (Object?.keys(storeById)?.length > 0) {
  //     setSelectedStore(storeById);
  //   }
  // }, [storeById]);
  useEffect(() => {
    const initialStates = {};

    filteredData?.orders?.forEach((order) => {
      const isViewInvoice =
        order?.isPacked === true || order?.isCancelled === true;

      // const isViewProducts =
      //   order?.isPacked === true && order?.isCancelled === false
      //     ? false
      //     : order?.isAccepted === false ||
      //       (order?.isAccepted === true && order?.isPacked === false)
      //     ? true
      //     : order?.isCancelled === true
      //     ? true
      //     : false;
      const isViewProducts = true;
      const checkOrder = order?.isPacked === true;
      const isViewLabel =
        selected !== "collect" || !order?.isCollect
          ? order?.isAccepted === true && order?.isDispatched === false
          : order?.isAccepted === true && order?.isCollected === false;
      initialStates[order?.OID] = {
        isViewInvoice,
        isViewProducts,
        checkOrder,
        isViewLabel,
      };
    });

    setOrderViewStates(initialStates);
  }, [filteredData, selected]);

  const handleViewImage = (order) => {
    if (order?.filePath?.length > 0) {
      window.open(order?.filePath);
    } else if (order?.pdfPath?.length > 0) {
      window.open(order?.pdfPath);
    }
  };

  const totalPages = data?.totalPages || 1;
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  useEffect(() => {
    if (data?.orders) {
      setFilteredData(data);
      const newCounts = {
        clinic: data?.counts?.isClinic,
        collect: data?.counts?.isCollect,
        address: data?.counts?.isAddress,
      };
      const newStatusCounts = {
        all: data?.counts?.all,
        accept: data?.counts?.isAccepted,
        packed: data?.counts?.isPacked,
        dispatched: data?.counts?.isDispatched,
        delivered: data?.counts?.isDelivered,
        cancelled: data?.counts?.isCancelled,
      };
      setCounts(newCounts);
      setStatusCounts(newStatusCounts);
    }
  }, [data]);

  useEffect(() => {
    if (data && data?.orders) {
    }
  }, [data]);
  const formatTime = (timeString) => {
    const date = new Date(timeString);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      timeZone: "Asia/Kolkata"
    });
  };
  const updatedOrderFilterButtons = OrderFilterButtons?.map((button) => ({
    ...button,
    count: counts[button.value]?.toString()?.padStart(2, "0"),
  }));

  const updatedOrderStatusButtons = OrderStatusButtons?.filter((button) => {
    if (selected === "collect" && button.value === "dispatched") {
      return false;
    }
    return true;
  })?.map((button) => {
    if (selected === "collect" && button.value === "delivered") {
      return {
        ...button,
        label: "Collected",
        value: "collected",
        count: statusCounts["collected"]?.toString()?.padStart(2, "0") || "00",
      };
    }
    return {
      ...button,
      count: statusCounts[button.value]?.toString()?.padStart(2, "0"),
    };
  });
  useEffect(() => {
    const payload = getPayload(selected, filterByStatus);

    if (payload && Object.keys(payload).length > 0) {
      setCurrentPage(1);
    }
    if (filterByStatus === "collected" && selected !== "collect") {
      setFilterByStatus("delivered");
    } else if (
      (filterByStatus === "delivered" || filterByStatus === "dispatched") &&
      selected === "collect"
    ) {
      setFilterByStatus("collected");
    }
  }, [selected, filterByStatus]);

  const handleButtonClick = (value) => {
    setSelected(value);
  };
  const handleFilterByClick = (value) => {
    setFilterByStatus(value);
  };
  useEffect(() => {
    if (data && data?.orders) {
      const newCounts = {
        all: data?.counts?.total,
        clinic: data?.counts?.isClinic,
        collect: data?.counts?.isCollect,
        address: data?.counts?.isAddress,
      };
      const newStatusCounts = {
        all: data?.counts?.all,
        accept: data?.counts?.isAccepted,
        packed: data?.counts?.isPacked,
        dispatched: data?.counts?.isDispatched,
        delivered: data?.counts?.isDelivered,
        cancelled: data?.counts?.isCancelled,
        collected: data?.counts?.isCollected,
      };
      setCounts(newCounts);
      setStatusCounts(newStatusCounts);
    }
  }, [data]);
  return (
    <>
      <SearchSelectStore
        stores={stores}
        formik={formik ? formik : null}
        selectedStore={selectedStore}
        setSelectedStore={setSelectedStore}
      />
      <Loader loading={loading} />
      {Object?.keys(storeById)?.length > 0 ? (
        <>
          <div className="grid grid-cols-12 gap-[8px] mb-2 mt-5">
            <ButtonGroup
              boxClass="col-span-3"
              buttons={updatedOrderFilterButtons}
              onButtonClick={handleButtonClick}
              selected={selected}
            />
          </div>
          <div className="grid grid-cols-12 gap-[8px] mb-3">
            <ButtonGroup
              boxClass="col-span-2"
              buttons={updatedOrderStatusButtons}
              onButtonClick={handleFilterByClick}
              selected={filterByStatus}
            />
          </div>
        </>
      ) : null}
      <div>
        <Formik

        // onSubmit={handleSubmit}
        >
          {({ values, handleChange, setFieldValue }) => (
            <Form className="dashboard-container">
              <div className="grid grid-cols-12 gap-[8px] mb-3">
                {filteredData?.orders?.length > 0 &&
                Object?.keys(storeById)?.length > 0
                  ? filteredData?.orders?.map((order, index) => {
                      const states = orderViewStates[order.OID] || {
                        isViewInvoice: false,
                        isViewProducts: true,
                      };
                      const invoiceLength =
                        order?.invoice !== null
                          ? Object.keys(order?.invoice)
                          : 0;
                      const filterdInvData = invoiceDetails?.find(
                        (item) => item?.orderId === order.OID
                      );
                      const orderType = order?.isClinic
                        ? "clinic"
                        : order?.isCollect
                        ? "collect"
                        : order?.isAddress
                        ? "address"
                        : "";
                      return (
                        <div
                          className="col-span-12 lg:col-span-6 mt-5"
                          key={index}
                        >
                          <div className="border border-primary-100 p-3 rounded-[12px] bg-white">
                            <div className="px-3.5 py-2 bg-primary-50 rounded-[4px] overflow-hidden relative">
                              <div
                                className={`w-[8px] h-[100%] left-0 top-0 rounded-[20px] bottom-0 absolute ${
                                  !order?.isCancelled
                                    ? (order?.isAccepted &&
                                        order?.isPacked &&
                                        order?.isDispatched &&
                                        order?.isDelivered) ||
                                      order?.isCollected
                                      ? "bg-[#4dff79]"
                                      : order?.isAccepted &&
                                        order?.isPacked &&
                                        order?.isDispatched
                                      ? "bg-[#6b70dd]"
                                      : order?.isAccepted &&
                                        order?.isPacked &&
                                        orderType !== "collect"
                                      ? "bg-[#54ddd5]"
                                      : order?.isAccepted
                                      ? "bg-[#d2dd56]"
                                      : ""
                                    : ""
                                }`}
                              ></div>
                              <div className="grid grid-cols-12 gap-[8px]">
                                <div className="col-span-12 md:col-span-4 lg:col-span-6 xl:col-span-4">
                                  <div>
                                    <h2 className="mb-1 font-medium text-[16px] xl:text-[20px] text-black-lose">
                                      {order?.OID || "Order ID"}
                                    </h2>
                                    <p className="mb-1 text-secondry-600 text-[16px]">
                                      {order?.patientDetail?.name || order?.patientDetail?.surname
                                        ? `${order?.patientDetail?.name || ""} ${order?.patientDetail?.surname || ""}`
                                        : "Patient Name"}
                                    </p>
                                    <p className="mb-1 text-secondry-600 text-[16px]">
                                      {order?.patientDetail?.phoneNumber || "Patient Number"}
                                    </p>
                                  </div>
                                </div>
                                <div className="col-span-12 md:col-span-4 lg:col-span-6 xl:col-span-4">
                                  <div>
                                    <h2 className="mb-1 font-medium text-[16px] xl:text-[20px] text-black-lose truncate max-w-full overflow-hidden text-ellipsis whitespace-nowrap">
                                      {order?.doctor?.personalInfo?.name || order?.doctor?.personalInfo?.surname
                                        ? `${order?.doctor?.personalInfo?.name || ""} ${order?.doctor?.personalInfo?.surname || ""}`
                                        : "Doctor Name"}
                                    </h2>
                                    {/* <p className="mb-1 text-secondry-600 text-[16px] truncate">
                                      {order?.doctor?.personalInfo?.clinicName || "Clinic Name"}
                                    </p> */}
                                    <p className="mb-1 text-secondry-600 text-[16px]">
                                      {formatDate(order?.createdAt) || ""}
                                    </p>
                                    <p className="mb-1 text-secondry-600 text-[16px]">
                                      Count: <span className="font-medium">
                                      {order?.orderProducts?.reduce(
                                        (total, product) => total + (Number(product?.orderQty) || 0),
                                        0
                                      ) || 0}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                                <div className="col-span-12 md:col-span-4 lg:col-span-6 xl:col-span-4">
                                  <div>
                                    <p className="mb-1 text-black-lose text-[16px] font-medium">
                                      T1
                                      <span
                                        className={
                                          order?.createdAt?.length > 0
                                            ? `text-secondry-500 pl-2`
                                            : `text-primary-600 pl-2`
                                        }
                                      >
                                        {/* <span>{hours}</span>:
                                      <span>{minutes}</span>:
                                      <span>{seconds}</span> */}
                                        {order?.createdAt
                                          ? formatTime(order?.createdAt)
                                          : "00:00"}{" "}
                                        &nbsp;
                                      </span>
                                    </p>
                                    <p className="mb-1 text-black-lose text-[16px] font-medium">
                                      T2
                                      <span
                                        className={
                                          (order?.isCollect &&
                                            order?.packedTime?.length > 0) ||
                                          order?.dispatchTime?.length > 0
                                            ? `text-secondry-500 pl-2`
                                            : `text-primary-600 pl-2`
                                        }
                                      >
                                        {order?.isCollect &&
                                        order?.packedTime?.length > 0
                                          ? formatTime(order?.packedTime) ||
                                            "00:00"
                                          : order?.dispatchTime?.length > 0
                                          ? formatTime(order?.dispatchTime)
                                          : "00:00"}{" "}
                                        &nbsp;
                                      </span>
                                    </p>
                                    <p className="mb-1 text-black-lose text-[16px] font-medium">
                                      T3
                                      <span
                                        className={
                                          (order?.isCollect &&
                                            order?.collectedTime?.length > 0) ||
                                          order?.deliveredTime?.length > 0
                                            ? `text-secondry-500 pl-2`
                                            : `text-primary-600 pl-2`
                                        }
                                      >
                                        {order?.isCollect &&
                                        order?.collectedTime?.length > 0
                                          ? formatTime(order?.collectedTime) ||
                                            "00:00"
                                          : order?.deliveredTime?.length > 0
                                          ? formatTime(order?.deliveredTime)
                                          : "00:00"}{" "}
                                        &nbsp;
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </div>

                              {order?.isAddress && (
                                <div className="">
                                  <h2 className="mb-1 font-medium text-[16px] xl:text-[20px] text-black-lose">
                                    Delivery Address
                                  </h2>
                                  <p className="mb-1 text-secondry-600 text-[16px] w-5/6">
                                    {[
                                      order?.isClinic
                                        ? "Clinic "
                                        : order?.isCollect
                                        ? "Collect "
                                        : order?.isAddress
                                        ? ""
                                        : "",
                                      order?.addressType,
                                      order?.premisesNoFloor
                                        ? ` ${order?.premisesNoFloor}`
                                        : "",
                                      order?.premisesName,
                                      order?.landmark,
                                    ]
                                      .filter(Boolean)
                                      .join(", ")}
                                  </p>{" "}
                                  <p className="mb-1 text-secondry-600 text-[16px] w-5/6">
                                    {[
                                      order?.areaRoad,
                                      order?.city,
                                      order?.pincode,
                                      order?.state,
                                    ]
                                      .filter(Boolean)
                                      .join(", ")}
                                  </p>
                                  <p className="mb-1 text-secondry-600 text-[16px]"></p>
                                </div>
                              )}

                              <div
                                className={`w-[8px] h-[100%] right-0 top-0 rounded-[20px] bottom-0 absolute ${
                                  orderType === "clinic"
                                    ? "bg-[#E4DCDC]"
                                    : orderType === "collect"
                                    ? "bg-[#9F8383]"
                                    : orderType === "address"
                                    ? "bg-[#141010]"
                                    : "bg-[#E4DCDC]"
                                }`}
                              ></div>
                            </div>
                            {states.isViewInvoice && (
                              <div className="grid grid-cols-12 gap-[8px] mt-3">
                                {order?.invoice?.invoiceNo && (
                                  <div className="col-span-5">
                                    <Input
                                      placeholder="Enter"
                                      inputBox="mb-0"
                                      type="text"
                                      labelName="Invoice NO."
                                      // name="manufacturer"
                                      labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                                      className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                                      value={
                                        invoiceLength?.length > 0
                                          ? order?.invoice?.invoiceNo
                                          : filterdInvData?.invoiceData
                                              ?.invoiceNo || null
                                      }
                                      disabled
                                    />
                                  </div>
                                )}

                                {order?.invoice?.invoiceAmount && (
                                  <div className="col-span-5">
                                    <div>
                                      <Input
                                        placeholder="Enter"
                                        inputBox="mb-0"
                                        type="text"
                                        labelName="Invoice Amount"
                                        // name="manufacturer"
                                        labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                                        className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                                        // value={invoiceData?.invoiceAmount || null}
                                        value={
                                          invoiceLength?.length > 0
                                            ? order?.invoice?.invoiceAmount
                                            : filterdInvData?.invoiceData
                                                ?.invoiceAmount || null
                                        }
                                        // onChange={handleChange}
                                      />
                                    </div>
                                  </div>
                                )}
                                {order?.payment &&
                                  order?.invoice?.invoiceNo && (
                                    <div className="col-span-2">
                                      <div className="uppercase text-center font-medium text-[16px] h-full max-h-[56px] bg-primary-50 py-[15px] px-[16px] rounded-[8px] border border-primary-50 focus-within:border focus-within:border-primary-500 transition-all duration-500 cursor-pointer">
                                        {order?.payment || ""}
                                      </div>
                                    </div>
                                  )}
                              </div>
                            )}
                            {states?.isViewProducts && (
                              <div className="my-3 medicine-table h-[100%]">
                                {order?.orderProducts?.length > 0
                                  ? order.orderProducts.map((product, index) => {
                                      const tags = getProductRowTags(product);
                                      return (
                                        <div
                                          key={index}
                                          className="flex items-center flex-wrap justify-between py-2 px-3 bg-primary-300 rounded-[6px] mb-2"
                                        >
                                          <div className="text-sm font-medium flex items-center gap-2 flex-wrap">
                                            <span className="font-bold">
                                              {product?.orderQty || 0} • {product?.productName || "Product"}
                                            </span>{" "}
                                            • {product?.type || "Type"} {product?.uom || "Units"} • ₹
                                            {product?.mrp || 0} • {product?.discount || 0}%
                                            {tags.length > 0 && (
                                              <div className="flex items-center gap-1 flex-wrap ml-2">
                                                {tags.map((tag, tIdx) => {
                                                  const isNRx = tag.name?.toUpperCase()?.includes("NRX");
                                                  return (
                                                    <span
                                                      key={tag.id || `${tag.name}-${tIdx}`}
                                                      className={`inline-flex items-center px-1.5 py-0.5 rounded-[4px] text-[10px] font-bold tracking-tight border ${
                                                        isNRx
                                                          ? "bg-red-50 text-red-700 border-red-300"
                                                          : "bg-white text-primary-800 border-primary-200 shadow-2xs"
                                                      }`}
                                                      style={!isNRx ? { color: tag.color || "#1D4ED8" } : {}}
                                                      title={tag.source ? `${tag.name} (${tag.source === "drug" ? "Drug Tag" : "Product Tag"})` : tag.name}
                                                    >
                                                      {tag.name}
                                                    </span>
                                                  );
                                                })}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      );
                                    })
                                  : null}
                              </div>
                            )}
                            
                            <div className="border border-primary-100 p-2 rounded-[8px] bg-white">
                              <div className="flex items-left flex flex-col flex-wrap justify-between">
                                <h4 className="text-primary-700 font-medium text-[16px] gap-0 flex-center">
                                  ~Net: ₹{order?.billing?.payableAmount}&nbsp;&nbsp;&nbsp;
                                  <span className="text-success-600">| Discount: ₹{order?.billing?.totalDiscount}
                                  </span>
                                </h4>
                                <p className="text-primary-400 font-medium text-[12px]">
                                  <span className="text-primary-500 font-semibold text-[12px]">Sub-Total: ₹{order?.billing?.subTotal}&nbsp;</span>
                                  • Handling Fee: ₹{order?.billing?.handlingFee === 0 ? "Free" : order?.billing?.handlingFee}&nbsp;
                                  • Small Cart Fee: ₹{order?.billing?.smallCartFee === 0 ? "Free" : order?.billing?.smallCartFee}&nbsp;
                                  • Delivery Charges: ₹{order?.billing?.deliveryCharges === 0 ? "Free" : order?.billing?.deliveryCharges}
                                </p>
                              </div>
                            </div>
                            <div className="relative pt-3 flex items-center justify-between overflow-hidden">
                              <div>
                                {/* {!order.isAccepted && !order.isCancelled && (
                                  <Button
                                    className="flex text-[13px] items-center justify-center gap-2 text-white bg-primary-600 h-[36px] w-full py-[5px] px-[15px] rounded-full shadow-none outline-none"
                                    type="button"
                                    // onClick={() =>
                                    //   handleChangeStatus(order.OID, "Accepted")
                                    // }
                                  >
                                    <CheckedBg />
                                    Accept
                                  </Button>
                                )}
                                {!order.isCancelled &&
                                  order.isAccepted &&
                                  !order.isPacked && (
                                    <Button
                                      className=" flex text-[13px] items-center justify-center gap-2 text-white bg-primary-600 h-[36px] w-full py-[5px] px-[15px] rounded-full shadow-none outline-none"
                                      type="button"
                                      // onClick={() =>
                                      //   handleChangeStatus(order.OID, "Packed")
                                      // }
                                    >
                                      <Packed />
                                      Packed
                                    </Button>
                                  )}
                                {selected !== "collect" &&
                                  !order.isCancelled &&
                                  order.isPacked &&
                                  !order.isDispatched && (
                                    <Button
                                      className="flex text-[13px] items-center justify-center gap-2 text-white bg-primary-600 h-[36px] w-full py-[5px] px-[15px] rounded-full shadow-none outline-none"
                                      type="button"
                                      // onClick={() =>
                                      //   handleChangeStatus(
                                      //     order.OID,
                                      //     "Dispatched"
                                      //   )
                                      // }
                                    >
                                      <Shipping />
                                      Dispatched
                                    </Button>
                                  )}
                                {selected !== "collect" &&
                                  !order?.isCancelled &&
                                  order?.isDispatched &&
                                  !order?.isDelivered && (
                                    <Button
                                      className="flex text-[13px] items-center justify-center gap-2 text-white bg-primary-600 h-[36px] w-full py-[5px] px-[15px] rounded-full shadow-none outline-none"
                                      type="button"
                                      // onClick={() =>
                                      //   handleChangeStatus(order.OID, "Delivered")
                                      // }
                                    >
                                      <DobbleCheck />
                                      Delivered
                                    </Button>
                                  )}
                                {selected === "collect" &&
                                  !order?.isCollected &&
                                  !order?.isCancelled &&
                                  order?.isAccepted &&
                                  order?.isPacked && (
                                    <Button
                                      className=" flex text-[13px] items-center justify-center gap-2 text-white bg-primary-600 h-[36px] w-full py-[5px] px-[15px] rounded-full shadow-none outline-none"
                                      type="button"
                                      // onClick={() =>
                                      //   handleChangeStatus(
                                      //     order.OID,
                                      //     "collected",
                                      //     order
                                      //   )
                                      // }
                                    >
                                      <Packed />
                                      Collect
                                    </Button>
                                  )}
                                {!order?.isCancelled &&
                                  (order?.isDelivered ||
                                    order?.isCollected) && (
                                    <Button
                                      className="flex text-[13px] items-center justify-center gap-2 bg-success-900 h-[36px] w-full py-[5px] px-[15px] rounded-full shadow-none outline-none"
                                      type="button"
                                      disabled
                                    >
                                      <Complete />
                                      Completed
                                    </Button>
                                  )} */}
                                {(() => {
                                  if (!order.isAccepted && !order.isCancelled) {
                                    return (
                                      <Button
                                        className="flex text-[13px] items-center justify-center gap-2 text-white bg-primary-600 h-[36px] w-full py-[5px] px-[15px] rounded-full shadow-none outline-none"
                                        type="button"
                                      >
                                        <CheckedBg />
                                        Accept
                                      </Button>
                                    );
                                  } else if (
                                    !order.isCancelled &&
                                    order.isAccepted &&
                                    !order.isPacked
                                  ) {
                                    return (
                                      <Button
                                        className="flex text-[13px] items-center justify-center gap-2 text-white bg-primary-600 h-[36px] w-full py-[5px] px-[15px] rounded-full shadow-none outline-none"
                                        type="button"
                                      >
                                        <Packed />
                                        Accepted
                                      </Button>
                                    );
                                  } else if (
                                    (selected !== "collect" ||
                                      !order.isCollect) &&
                                    (order?.isClinic || order?.isAddress) &&
                                    !order.isCancelled &&
                                    order.isPacked &&
                                    !order.isDispatched
                                  ) {
                                    return (
                                      <Button
                                        className="flex text-[13px] items-center justify-center gap-2 text-white bg-primary-600 h-[36px] w-full py-[5px] px-[15px] rounded-full shadow-none outline-none"
                                        type="button"
                                      >
                                        <Shipping />
                                        Packed
                                      </Button>
                                    );
                                  } else if (
                                    (selected !== "collect" ||
                                      !order.isCollect) &&
                                    (order?.isClinic || order?.isAddress) &&
                                    !order.isCancelled &&
                                    order.isDispatched &&
                                    !order.isDelivered
                                  ) {
                                    return (
                                      <Button
                                        className="flex text-[13px] items-center justify-center gap-2 text-white bg-primary-600 h-[36px] w-full py-[5px] px-[15px] rounded-full shadow-none outline-none"
                                        type="button"
                                      >
                                        <DobbleCheck />
                                        Dispatched
                                      </Button>
                                    );
                                  } else if (
                                    (selected === "collect" ||
                                      order?.isCollect) &&
                                    !order.isCancelled &&
                                    order.isAccepted &&
                                    order.isPacked &&
                                    !order?.isDelivered &&
                                    !order?.isDispatched &&
                                    !order.isCollected
                                  ) {
                                    return (
                                      <Button
                                        className="flex text-[13px] items-center justify-center gap-2 text-white bg-primary-600 h-[36px] w-full py-[5px] px-[15px] rounded-full shadow-none outline-none"
                                        type="button"
                                      >
                                        <Packed />
                                        Packed
                                      </Button>
                                    );
                                  } else if (
                                    !order.isCancelled &&
                                    (order.isDelivered || order.isCollected)
                                  ) {
                                    return (
                                      <Button
                                        className="flex text-[13px] items-center justify-center gap-2 bg-success-900 h-[36px] w-full py-[5px] px-[15px] rounded-full shadow-none outline-none"
                                        type="button"
                                        disabled
                                      >
                                        <Complete />
                                        Completed
                                      </Button>
                                    );
                                  }
                                })()}
                              </div>
                              {!order?.isCancelled && (
                                <div className="flex items-center gap-2">
                                  {/* {states?.isViewInvoice && (
                                    <Button className="flex text-[13px] whitespace-nowrap items-center justify-center gap-2 text-secondry-600 border bg-primary-50 border-primary-600 h-[36px] w-full py-[5px] px-[15px] rounded-full shadow-none outline-none">
                                      <CreateOrder />
                                      Label
                                    </Button>
                                  )} */}

                                  <Button
                                    onClick={() => handleViewImage(order)}
                                    type="button"
                                    className={`flex text-[13px] whitespace-nowrap items-center justify-center gap-2 text-secondry-600 border h-[36px] w-full py-[5px] px-[15px] rounded-full shadow-none outline-none ${
                                      order?.filePath?.length > 0 || order?.pdfPath?.length > 0
                                        ? "bg-primary-50 border-primary-600"
                                        : "bg-gray-100 "
                                    }`}
                                  >
                                    <OpenLink fill="#513e3e" />
                                    Open Rx
                                  </Button>
                                </div>
                              )}
                            </div>
                            {order?.isCancelled && (
                              <div className="flex items-center text-[13px] gap-5 bg-yellow-600 border-2 border-yellow-100 w-[100%] py-[8px] px-[20px] rounded-[8px] shadow-none outline-none">
                                <span className="text-red-700 font-medium capitalize block">
                                  Order cancelled{" "}
                                </span>
                                <ul className="flex items-center">
                                  <li className="list-disc list-inside text-secondry-600">
                                    {order?.cancelReason}
                                  </li>
                                </ul>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })
                  : //   <div className="col-span-12 ">
                    //     <p className="pt-5 text-gray-500 text-center">
                    //       No orders found
                    //     </p>
                    //   </div>
                    // )}
                    null}
              </div>
            </Form>
          )}
        </Formik>
      </div>
      {filteredData?.orders?.length > 0 &&
        Object?.keys(storeById)?.length > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPreviousPage={handlePreviousPage}
            onNextPage={handleNextPage}
            isPreviousDisabled={currentPage === 1}
            isNextDisabled={currentPage === totalPages}
            itemLength={filteredData?.orders?.length || filteredData?.length}
            totalItems={filteredData?.totalItems || data?.totalItems}
          />
        )}
    </>
  );
};

export default StoreDashboard;
